import { Text } from '@mantine/core';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';
import { ChartTipEntity } from '@/entities/ChartTips';

import s from './ChartTip.module.scss';

type ChartTipProps = {
  tip: ChartTipEntity;
  setTip: (tip: string) => void;
};

const ChartTip: React.FC<ChartTipProps> = ({ tip, setTip }) => {
  const handleClick = React.useCallback(() => {
    setTip(tip.suggestion);
  }, [setTip, tip.suggestion]);

  return (
    <BaseClickable type="button" onClick={handleClick} className={s.root}>
      <Text fw={500} lh="md" className={s.root__text} size="sm" lineClamp={2}>
        {tip.suggestion}
      </Text>
    </BaseClickable>
  );
};

export default React.memo(ChartTip);
